<template>
  <div class="synchro-settings__onboardingview">
    <div class="synchro-settings__box">
      <div class="popup__label">
        {{ $t("headings.synchronizationSettings") }}
      </div>
      <p style="text-align: center" class="mt-4">
        {{ $t("texts.synchronizationSettings") }}
      </p>
      <synchro-settings-form @submit="onSubmit()" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import SynchroSettingsForm from "../settings/SynchroSettingsForm.vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const redirectPath = computed(() => {
  if (route.redirectedFrom) {
    return {
      path: route.redirectedFrom.path
    };
  }
  return {
    name: "models-explorer"
  };
});

function onSubmit() {
  router.push(redirectPath.value);
}
</script>

<style lang="scss">
.synchro-settings {
  &__onboardingview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  &__box {
    background-color: var(--color-background-deep);
    padding: 2rem;
    max-width: 50rem;
    box-shadow: 0 0.1rem 0.5rem rgb(0 0 0 / 20%);
    padding-top: 0;
  }
}
</style>
